import React from "react";
const PointComponent = () => {
  return (
    <>
      <p className="title">ポイントについて</p>
      <p className="subtitle">
        もなかは先払いポイント購入制です。
        <br />
        データ通信料はお客様のご負担となります。
      </p>
      <p className="point-trading">
        <span className="text-danger">※</span>
        1円＝0.75pts
      </p>
      <div>
        <table className="call-feature-table">
          <thead>
            <tr>
              <th>通話機能</th>
              <th>発信時</th>
              <th>着信時</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>音声通話</td>
              <td colSpan={2}>200pts/1分</td>
            </tr>
            <tr>
              <td>ビデオ通話</td>
              <td colSpan={2}>250pts/1分</td>
            </tr>
          </tbody>
        </table>
        <table className="other-table">
          <thead>
            <tr className="other-table-header">
              <th>その他</th>
              <th>料金</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>プロフィール　閲覧</td>
              <td className="free-text">無料</td>
            </tr>
            <tr>
              <td>ブログ投稿</td>
              <td className="free-text">無料</td>
            </tr>
          </tbody>
        </table>
        <table className="message-feature-table">
          <thead>
            <tr>
              <th>メッセージ機能</th>
              <th>受信時</th>
              <th>送信時</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>メール送信</td>
              <td className="free-text">無料</td>
              <td>80pts/1通</td>
            </tr>
            <tr>
              <td>画像添付</td>
              <td>50pts/1通</td>
              <td>100pts/1通</td>
            </tr>
            <tr>
              <td>動画添付</td>
              <td>100pts/1通</td>
              <td>150pts/1通</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
export default PointComponent;